<div class="flex flex-col items-center justify-center p-8 md:p-12 text-center mt-4">

  <!-- Ícone Lucide em círculo colorido -->
  <div *ngIf="icone && !imagem"
       [ngClass]="bgClass"
       class="w-24 h-24 rounded-full flex items-center justify-center mb-6 flex-shrink-0">
    <lucide-icon [name]="icone" [ngClass]="iconClass" class="w-12 h-12" [strokeWidth]="2"></lucide-icon>
  </div>

  <!-- Ilustração PNG/SVG -->
  <img *ngIf="imagem"
       [src]="imagem"
       alt="Imagem de estado vazio"
       class="w-40 h-auto mx-auto mb-5 opacity-90">

  <!-- Título -->
  <h3 *ngIf="titulo" class="text-base font-semibold text-slate-800 dark:text-gray-100 mb-2 max-w-sm mx-auto">
    {{ titulo }}
  </h3>

  <!-- Descrição opcional -->
  <p *ngIf="descricao" class="text-sm text-slate-500 dark:text-slate-400 max-w-sm mx-auto leading-relaxed">
    {{ descricao }}
  </p>

  <!-- Slot para conteúdo extra (ex: botão de ação) -->
  <ng-content></ng-content>

</div>

